import { BoxMargin } from 'tabler-icons-react';
import {
  ECOM_WEBSTORE_SECTION_BOUND_TYPE,
  ECOM_WEBSTORE_SECTION_TYPE_ENUM
} from '../../../../../../config/constants';

const MEDIA_POSITION_ENUM = {
  LEFT: 'left',
  RIGHT: 'right'
};

const MEDIA_LAYOUT_ENUM = {
  STACKED: 'stacked',
  TWO_COLUMNS: 'twoColumns',
  THUMBNAILS: 'thumbnails',
  CAROUSEL_THUMBNAILS: 'carouselThumbnails'
};

const MEDIA_SIZE_ENUM = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

const configNameValues = {
  colorScheme: 'colorScheme',
  desktopMediaPosition: 'desktopMediaPosition',
  desktopMediaLayout: 'desktopMediaLayout',
  mediaSize: 'mediaSize',
  switchToVariantImage: 'switchToVariantImage',
  enableImageNotAvailablePreview: 'enableImageNotAvailablePreview'
};

const configDefaultValues = {
  [configNameValues.colorScheme]: '1',
  [configNameValues.desktopMediaPosition]: MEDIA_POSITION_ENUM.LEFT,
  [configNameValues.desktopMediaLayout]: MEDIA_LAYOUT_ENUM.THUMBNAILS,
  [configNameValues.mediaSize]: MEDIA_SIZE_ENUM.MEDIUM,
  [configNameValues.switchToVariantImage]: 'true',
  [configNameValues.enableImageNotAvailablePreview]: 'true'
};

const configOptions = {};

const config = {
  type: ECOM_WEBSTORE_SECTION_TYPE_ENUM.PRODUCT_INFORMATION,
  title: 'Product information',
  icon: BoxMargin,
  allowedBounds: [ECOM_WEBSTORE_SECTION_BOUND_TYPE.BODY],
  Component: null,
  configOptions,
  isPermanent: true,
  cannotCreate: true,
  maxItemCount: null,
  blocks: [],
  defaultConfig: configDefaultValues,
  onFetchDataConfig: (sectionConfigValues, pathname, selectedResources) => ({
    type: 'ecomStoreProduct',
    entityId: null,
    filter: { urlHandle: selectedResources.ecomStoreProduct?.urlHandle }
  })
};

export {
  config,
  configOptions,
  configNameValues,
  configDefaultValues,
  MEDIA_LAYOUT_ENUM,
  MEDIA_POSITION_ENUM,
  MEDIA_SIZE_ENUM
};
